
import { MDCTextField } from '@material/textfield';
import { Vue, Model, Prop } from 'vue-property-decorator';

export default class MaterialTextfield extends Vue {

    @Model('modelValue', { type: String, default: '' }) readonly value!: string;
    @Prop(String) readonly label!: string;
    @Prop({ type: String, default: 'text' }) readonly type!: string;
    @Prop(String) readonly inputId?: string;
    @Prop(String) readonly pattern?: string;
    @Prop(Boolean) readonly required?: boolean;

    private ctrl?: MDCTextField;

    mounted() {
        this.ctrl = MDCTextField.attachTo(this.$el);
        this.ctrl.value = this.value;
        this.ctrl.listen('change', this.changed);
    }

    updated() {
        this.ctrl?.destroy();
        this.ctrl = MDCTextField.attachTo(this.$el);
        this.ctrl.value = this.value;
        this.ctrl.listen('change', this.changed);
    }

    unmounted() {
        this.ctrl?.destroy();
    }

    private changed() {
        if (!this.ctrl || !this.ctrl.valid) return;
        this.$emit('update:modelValue', this.ctrl.value);
    }
}
